import 'styles/components/dropdown-menu.scss'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

const DropdownMenu = ({ arrow, className, children, show, onClick }) => {
  if (!show) {
    return null
  }
  const dropdownMenuClassName = classnames('dropdown-menu', className, {
    'has-arrow': arrow
  })

  return (
    <Fragment>
      <div className="dropdown-bg" role="presentation" onClick={onClick} />
      <div className={dropdownMenuClassName}>{children}</div>
    </Fragment>
  )
}

DropdownMenu.propTypes = {
  arrow: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

DropdownMenu.defaultProps = {
  arrow: true,
  className: null
}

export default DropdownMenu
